import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import {
  BORDER_RADIUS,
  BREAKPOINTS,
  PAYMENT_FOOTER_SHADOW,
} from '@src/styles/config';

const StyledPackageInfoItem = styled('div')`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  width: 100% !important;
  padding-top: 4.5px;

  .line-height-24 {
    line-height: 24px;
  }

  .price {
    display: flex;
    align-items: flex-end;
    line-height: 24px;

    .discount-price {
      font-size: ${(props) => (props?.isMobile ? '14px' : '16px')};
      font-weight: 700;
      color: ${COLOR.label2[100]};
    }

    .discount-price-unit {
      font-size: 14px;
      font-weight: 400;
      color: ${COLOR.label2[100]};
    }

    .underline {
      font-weight: 700;
      font-size: ${(props) => (props?.isMobile ? '14px' : '16px')};
      text-decoration: underline;
    }

    .line-through {
      text-decoration: line-through;
    }

    .original-price {
      font-size: ${(props) => (props?.isMobile ? '12px' : '14px')};
      font-weight: 400;
      color: ${COLOR.darkV2[64]};
    }

    .original-price-unit {
      font-size: 12px;
      font-weight: 400;
      color: ${COLOR.darkV2[64]};
    }

    .font-size-14 {
      font-size: 14px;
    }
  }

  .package-info-title-and-price {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 390px) {
      align-items: flex-start;
    }

    .title-wrapper {
      display: flex;
      gap: 4px;
      align-items: center;

      .tag-discount {
        .percent-icon {
          margin-right: 4px;
        }
        margin-left: 4px;
        background-color: #007aff14;
        color: #007aff;
        font-weight: 400;
        border-radius: 8px;
        padding: 4px 8px;
        font-size: 12px;
        display: flex;
        align-items: center;
      }

      .title {
        font-size: ${(props) => (props?.isMobile ? '14px' : '16px')};
        font-weight: 400;
        color: ${COLOR.label2[100]};
        line-height: 24px;
        white-space: nowrap;
      }

      .banner {
        padding: 4px 8px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 510;
        line-height: 16px;
        white-space: nowrap;
      }
      .auto-renewal {
        background-color: ${COLOR.secondary[80]};
        color: ${COLOR.secondary[100]};
      }

      .save-percent {
        background: ${COLOR.yellow.default};
        color: ${COLOR.indigo.default};
      }

      .most-popular {
        background: ${COLOR.yellow.default};
        color: ${COLOR.indigo.default};
        text-transform: uppercase;
        width: max-content;
        font-size: 12px;
        letter-spacing: -0.4px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 4px;
        .fire-icon {
          margin-bottom: 2px;
          width: 16px;
        }
      }
    }

    .price-wrapper {
      display: flex;
      gap: 4px;
      align-items: center;

      @media (max-width: 390px) {
        flex-direction: column-reverse;
      }
    }
  }
`;

const StyledPayment = styled('div')`
  position: relative;
  box-sizing: border-box;
  margin-bottom: 70px;

  .MuiGrid-root {
    margin-bottom: ${(props) =>
      props.useNewLegal && !props.isAutoRenew && '30px'};
  }

  .header-payment {
    padding: 24px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .icon {
      display: flex;
    }

    .icon-button {
      display: none;
    }

    .back-to-package {
      font-size: 16px;
      text-transform: none;
      padding: 8px 12px 8px 12px;
      border-radius: 100px;
      background-color: ${COLOR.white};
      position: absolute;
      left: 0;

      :hover {
        background-color: ${COLOR.black[16]};
      }
    }

    .back-to-package-mobile {
      color: ${COLOR.darkV2[80]};
      margin-right: 4px;
    }

    .title {
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
    }
  }

  .mobile-button {
    display: none;
  }

  .website-button {
    display: flex;
  }

  @media (max-width: ${BREAKPOINTS.SMD}px) {
    .mobile-button {
      display: flex !important;
    }

    .website-button,
    .medium-website-button {
      display: none !important;
    }

    .header-payment {
      justify-content: flex-start !important;
    }
  }

  @media (min-width: ${BREAKPOINTS.SMD}) and (max-width: ${BREAKPOINTS.MD}px) {
    .medium-website-button {
      display: flex !important;
    }
  }

  @media (max-width: ${BREAKPOINTS.MD}px) {
    .website-button {
      display: none !important;
    }

    .header-payment {
      .back-to-package {
        padding: 8px;
      }
    }
  }

  @media (min-width: ${BREAKPOINTS.MD}px) {
    .mobile-button,
    .medium-website-button {
      display: none !important;
    }

    .website-button {
      display: flex !important;
    }
  }

  .header {
    margin-bottom: 24px;
    text-align: center;

    .content {
      padding: 8px;

      color: ${COLOR.indigo.default};
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: -0.4px;
    }
  }

  .card {
    padding: 24px 32px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .subscription-wrapper {
    margin-top: 16px;
  }

  .footer {
    position: fixed;
    bottom: 0;
    max-width: 100%;
    box-sizing: border-box;
  }

  .show-mobile {
    display: none;
  }

  @media (min-width: ${BREAKPOINTS.MLG}px) and (max-width: ${BREAKPOINTS.CMLG -
    1}px) {
    .card {
      padding: 32px;
    }

    .show-desktop {
      display: ${(props) => (props.openSidebar ? 'none' : 'block')};
    }

    .show-mobile {
      display: ${(props) => (props.openSidebar ? 'block' : 'none')};
    }
  }

  @media (max-width: ${BREAKPOINTS.MLG - 1}px) {
    .card {
      padding: 32px;
    }

    .show-desktop {
      display: none;
    }

    .show-mobile {
      display: block;
    }
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: ${COLOR.indigo.default};
    line-height: 28px;
  }

  @media (max-width: 599px) {
    margin-bottom: ${(props) => (props.isAutoRenew ? '128px' : '72px')};
    background-color: ${(props) => props.isUIBuyTopupCharacters && '#fff'};
    border-radius: ${(props) => props.isUIBuyTopupCharacters && '16px'};
    .card {
      padding: ${(props) => (props.isUIBuyTopupCharacters ? '8px' : '16px')};
    }
  }

  @media (max-width: 650px) {
    .header-payment {
      .title {
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 32px;
      }

      .icon {
        display: none;
      }

      .icon-button {
        display: block;
      }
    }
  }

  .discount-unit-price {
    font-size: 14px;
    text-transform: lowercase;
  }

  .font-size-14 {
    font-size: 14px;
  }

  .font-size-16 {
    font-size: 16px;
  }

  .underline {
    text-decoration: underline;
    text-underline-offset: 2px;
  }

  .align-item-center {
    align-items: center;
  }

  .no-wrap {
    white-space: nowrap;
  }

  .text-indigo {
    color: ${COLOR.indigo.default};
  }

  .text-16 {
    font-size: 16px !important;
  }

  .font-bold-510 {
    font-weight: 510 !important;
  }

  .mb-4 {
    margin-bottom: 4px;
  }

  .line-through {
    text-decoration: line-through;
  }
`;

const StyledPackageInfo = styled('div')`
  .package-header {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    cursor: pointer;
    flex-wrap: wrap;
  }

  .note {
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    color: ${COLOR.darkV2[60]};
    text-align: right;
    margin-top: 8px;
  }

  .icon-info-rounded {
    font-size: 16px;
    z-index: 3;
    color: #1e164ea3;
    pointer-events: all;
  }

  .disabled {
    position: relative;
    z-index: 1;
    pointer-events: none;
  }

  .disabled-checkbox {
    opacity: 0.4;
    pointer-events: none;
  }
  .label-checkbox {
    margin-right: 0 !important;
  }

  .banner {
    padding: 4px 8px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 510;
    line-height: 16px;
    white-space: nowrap;
  }

  .using-text {
    font-weight: 700;
    color: ${COLOR.label2[100]};
    display: flex;
    align-items: center;
  }

  @media (max-width: ${BREAKPOINTS.SMD}px) {
    font-size: 14px;
  }

  .auto-renewal {
    background-color: ${COLOR.secondary[80]};
    color: ${COLOR.secondary[100]};
  }

  .save-percent {
    background: ${COLOR.yellow.default};
    color: ${COLOR.indigo.default};
  }

  .package-icon-active {
    display: flex;
    align-items: center;
    border-radius: 9999px;
    background-color: ${COLOR.primary};
    width: 48px;
    height: 48px;
  }

  .package-name {
    font-size: 20px;
    font-weight: bold;
    color: ${COLOR.darkBlue};
    margin: auto;
  }

  @media (max-width: ${BREAKPOINTS.SMD}px) {
    .package-name {
      font-size: 16px !important;
    }

    .mobile-label {
      display: block !important;
    }

    .website-label {
      display: none !important;
    }

    .package-toggle {
      gap: 4px !important;
    }

    .banner {
      font-size: 10px !important;
    }
  }

  @media (min-width: ${BREAKPOINTS.SMD}px) {
    .mobile-label {
      display: none !important;
    }

    .website-label {
      display: block !important;
    }
  }

  .vertical-center {
    display: flex;
    align-items: center;
  }

  .hidden {
    display: none;
  }

  .select-package {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 12px;
  }

  .py-20 {
    padding: 20px 0;
  }

  .package-toggle {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .package-duration-select {
    cursor: pointer;
    .MuiFormControlLabel-root {
      margin-right: 0;
    }

    margin-top: 4px;

    .flex-col {
      display: flex;
      flex-direction: column;
    }

    .flex-row {
      flex-direction: row;
    }

    .flex {
      display: flex;
    }

    .space-between {
      justify-content: space-between;
    }

    .flex-start {
      justify-content: flex-start;
    }

    .gap-8 {
      gap: 8px;
    }

    .gap-4 {
      gap: 4px;
    }

    .align-item-start {
      align-items: flex-start;
    }

    .align-item-center {
      align-items: center;
    }

    .align-item-end {
      align-items: flex-end;
    }

    .full-width {
      width: 100% !important;
    }

    .pt-12 {
      padding-top: 12px;
    }

    .pt-8 {
      padding-top: 8px;
    }

    .package-duration-card {
      padding-top: 4.5px;
    }

    .pb-12 {
      padding-bottom: 12px;
    }

    .pb-8 {
      padding-bottom: 8px;
    }

    .font-bold {
      font-weight: 700;
    }

    .gap-2 {
      gap: 2px;
    }

    .flex-end {
      justify-content: flex-end;
    }

    .text-dark-v2-64 {
      color: ${COLOR.darkV2[64]};
    }

    .text-14 {
      font-size: 14px;
    }

    .mt-1 {
      margin-top: 4px;
    }

    .py-3 {
      padding-top: 3px !important;
      padding-bottom: 3px !important;
    }

    .py-4 {
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }

    .px-6 {
      padding-left: 6px !important;
      padding-right: 6px !important;
    }

    .most-popular {
      border-radius: 480px;
      background: ${COLOR.yellow.default};
      color: ${COLOR.indigo.default};
      font-size: 12px;
      text-transform: uppercase;
    }
  }

  .label {
    border-radius: 480px;
    font-size: 12px;

    &.auto-renewal {
      color: ${COLOR.secondary[100]};
      background-color: ${COLOR.secondary[80]};
    }

    &.save-percent {
      background: ${COLOR.yellow.default};
      color: ${COLOR.indigo.default};
    }
  }
`;

const StyledPopover = styled(Popover)`
  .menu {
    padding: 4px 12px 12px 12px;

    .menu-item {
      border-radius: ${BORDER_RADIUS} !important;
      margin-top: 8px;
      padding: 0px !important;

      :hover {
        cursor: pointer;
        background-color: ${COLOR.indigo[8]};
      }
    }

    .selected {
      background-color: ${COLOR.yellow[16]};
    }
  }

  .name {
    font-weight: 700;
    margin-left: 10px;
    width: 160px;
    padding: 8px;
  }

  .package-icon {
    display: flex;
    align-items: center;
  }
`;

const StyledInvoice = styled('div')`
  display: flex;
  flex-direction: column;
  margin-top: 8px;

  .invoice-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: ${(props) => (props.hasInvoice ? 'default' : 'pointer')};

    .expand-icon {
      width: 24px;
      height: 24px;
      font-weight: 400;
      color: ${COLOR.indigo[80]};
    }
  }

  .title {
    font-size: 20px;
    font-weight: 700;
    color: ${COLOR.indigo.default};
    line-height: 28px;
  }

  .invoice-check-box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
  }

  .checkbox {
    padding: 0;
    color: ${COLOR.darkBlue} !important;
  }

  .invoice-collapse-wrapper {
    margin-top: ${(props) => (props.openCollapse ? '16px' : '0')};
    transition: height 300ms linear, opacity 250ms linear;
    display: ${(props) => (props.openCollapse ? 'block' : 'none')};
    height: ${(props) => (props.openCollapse ? 'auto' : '0px')};
    opacity: ${(props) => (props.openCollapse ? '1' : '0')};

    .note-item {
      display: flex;
      gap: 5px;
      align-items: flex-start;
      background-color: ${TRANSPARENT_COLOR.alert};
      padding: 12px;
      border-radius: 8px;
      margin-bottom: 16px;

      &.align-items-center {
        align-items: center !important;
      }

      .note-content {
        display: flex;
        flex-direction: column;
      }

      .note-title {
        font-size: 12px;
        font-weight: 400;
        color: ${COLOR.label[80]};
      }

      .note-description {
        font-size: 14px;
        font-weight: 400;
        color: ${COLOR.label[100]};
      }
    }

    .icon {
      width: 24px;
      height: 24px;
    }
  }
`;

const StyledCreateInvoice = styled('div')`
  border-radius: ${BORDER_RADIUS};
  display: flex;
  flex-direction: column;
  gap: 12px;

  span {
    color: ${COLOR.functionalRed.default};
  }

  .invoice-input {
    margin-top: 8px;
  }

  .MuiOutlinedInput-root {
    border-radius: ${BORDER_RADIUS};
  }

  p {
    font-weight: 500;
  }
`;

const StyledPaymentMethods = styled('div')`
  .MuiGrid-root {
    margin-bottom: 0px;
    .MuiGrid-item {
      margin-bottom: 0px;
    }
  }
  .title {
    margin-bottom: 16px;
  }

  .note {
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    color: ${COLOR.darkV2[60]};
    margin-bottom: 4px;
    margin-bottom: 4px;
    margin-top: -8px;
  }

  .flex-wrap {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
`;

const StyledPaymentMethodItem = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  border-radius: ${BORDER_RADIUS};
  padding: 12px 8px;
  background: ${COLOR.charcoal};
  border: 2px solid ${COLOR.charcoal};
  &:hover {
    cursor: pointer;
    background: ${COLOR.gray};
    border: 2px solid ${COLOR.gray};
  }
  .MuiGrid-item {
    margin-bottom: 0px;
  }
  ${({ disabled }) =>
    disabled &&
    `opacity: 0.32;
    &:hover {
      cursor: default ;
      background: ${COLOR.charcoal};
      border: 2px solid transparent;
    }
  `}

  ${({ selected }) =>
    selected &&
    `border: 2px solid ${COLOR.primary};
     background: none;
     &:hover {
      background: none;
      border: 2px solid ${COLOR.primary}
     }
  `}

  .name {
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
  }

  .logo {
    width: fit-content;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-img {
    max-width: 64px;
  }
`;

const StyledOrderInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .info-title {
    font-size: 16px;
    font-weight: 700;
  }

  .total {
    display: flex;
    justify-content: space-between;
  }

  .info-min-payment-amount {
    background-color: #ff950014;
    padding: 8px;
    border-radius: 8px;
    font-size: 14px;
    letter-spacing: -0.4px;
    color: #1c1c1e;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .info-rounded-icon {
    font-size: 18px;
    cursor: pointer;
    color: #ff9500;
  }
`;

const StyledUserOrderInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  .info_code {
    font-size: 16px;
    margin-right: 6px;
  }
  .user-info-content {
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.usePhoneCountryInput && '12px'};
  }

  .user-info-item {
    display: flex;
    align-items: start;
    gap: 4px;
    font-size: 16px;
    justify-content: space-between;

    .user-info-item-name {
      font-weight: 400;
    }
    .user-info-item-label {
      font-weight: 400;
    }

    .user-info-content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    .edit-icon {
      width: 20px;
      color: ${COLOR.black[32]};
      cursor: pointer;
    }

    .filter-item {
      display: flex;
      gap: 10px;
    }

    .phone-number-card {
      margin-left: ${(props) => props.usePhoneCountryInput && '4px'};
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .text-field-request {
      background-color: ${COLOR.white};
      width: 133px;

      .MuiOutlinedInput-root {
        border-radius: 100px;
        color: ${COLOR.functionYellow.default};
      }

      .MuiOutlinedInput-input {
        padding: 0px;
        font-size: 14px;
        line-height: 20px;
        font-weight: 400;
        letter-spacing: -0.4px;
        color: ${COLOR.indigo.default};
      }

      .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${COLOR.functionYellow.default};
      }
    }

    .phone-number-warning {
      font-size: 12px;
      line-height: 16px;
      font-weight: 400;
      letter-spacing: -0.4px;
      color: ${COLOR.functionalRed.default};
      margin-left: 8px;
    }

    .select-phone {
      position: relative;
    }

    .select-code-country {
      position: relative;
    }

    .phone_number_view {
      min-width: 90px;
    }

    .select-phone-country {
      display: flex;
      align-items: center;
      width: max-content;
    }
    .select-custom {
      background-color: #fff;
      position: absolute;
      width: 220px;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.16);
      top: 41px;
      overflow-y: auto;
      border-radius: 12px;
      z-index: 99;
    }
    .select-custom::-webkit-scrollbar {
      width: 8px;
    }

    .select-custom::-webkit-scrollbar-track {
      border-radius: 12px;
    }

    .select-custom::-webkit-scrollbar-thumb {
      border-radius: 12px;
    }

    .user-info-phone-number {
      height: 24px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 0px 8px;
      border-radius: 100px;
      border: 1px solid transparent;
      font-size: 14px;
      line-height: 20px;
    }

    .select-btn-phone-country {
      box-sizing: border-box;
      height: 32px;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 4px;
      padding-left: 10px;
      border-radius: 8px 0 0 8px;
      border: 1px solid ${COLOR.phoneInput};
      border-right: 0px;
      font-size: 16px;
      line-height: 20px;
      .country_flag {
        font-size: 16px;
      }
      img {
        width: 24px;
        height: 24px;
      }
      ${(props) =>
        !props.isPhoneNumberValid &&
        `
          border: 1px solid red;
          border-right: none
        `}
    }

    .user-info-phone-country {
      box-sizing: border-box;
      height: 32px;
      display: flex;
      width: 147px;
      align-items: center;
      gap: 8px;
      padding: 4px;
      border-radius: 0 8px 8px 0;
      border: 1px solid ${COLOR.phoneInput};
      font-size: 14px;
      line-height: 20px;
      ${(props) =>
        !props.isPhoneNumberValid &&
        `
          border-top: 1px solid red;
          border-bottom: 1px solid red;
          border-right: 1px solid red;
        `}
      .dial_code {
        font-weight: 400;
        font-size: 14px;
        color: #1c1c1e7a;
      }

      .input-change-country-phone {
        outline: none;
        border: none;
        font-size: 16px;
        width: 100%;
        line-height: 20px;
        font-weight: 400;
        color: ${COLOR.text};
        font-family: 'SF Pro', sans-serif;
        &::placeholder {
          font-size: 14px;
          color: #1c1c1e3d;
        }
      }

      input {
        &::-webkit-autofill {
          background-color: white !important;
        }
      }
      input:-webkit-autofill,
      input:-webkit-autofill:focus {
        transition: background-color 0s 600000s, color 0s 600000s !important;
      }
    }
  }

  .ml-8 {
    margin-left: 8px;
  }

  .ml-4 {
    margin-left: 4px;
  }
`;

const StyledOrder = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .details-text {
    color: #1c1c1ea3;
    font-size: 14px;
    letter-spacing: -0.4px;
  }

  .description-remaining-box {
    line-height: 20px;
  }

  .description-remaining-mobile {
    color: #1c1c1ea3;
    font-size: 14px;
    letter-spacing: -0.4px;
    margin-left: 4px;
    ul {
      padding: 0 0 0 30px !important;
    }
  }

  .package-info-card {
    display: flex;
    justify-content: space-between;
    align-items: start;
    font-size: 16px;
    .MuiTypography-root {
      font-size: 16px;
      font-weight: 400;
    }
    .package-info-title {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.4px;
    }

    .lower-case-text {
      text-transform: lowercase;
    }

    .package-info-detail {
      display: flex;
      gap: 4px;
      flex-direction: column;
      text-align: right;
      font-size: 16px;
      font-weight: 400;
      .MuiTypography-root {
        font-size: 16px;
      }
      .auto-renewal {
        padding: 4px 10px;
        border-radius: 16px;
        background-color: ${COLOR.indigo[8]};
        font-size: 16px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: -0.4px;
        color: ${COLOR.indigo[100]};
      }
    }

    .remaning-value-info {
      display: flex;
      align-items: center;
      .tooltip-remaning-value {
        color: #1e164ea3;
        margin-left: 2px;
      }
    }

    .details-price-resources {
      display: flex;
      align-items: center;
      .icon-info-rounded {
        color: #1e164ea3;
        margin-left: 2px;
      }
    }
  }
`;

const StyledVoucherBox = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;

  .package-info-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .text-field-request {
    background-color: ${COLOR.white};
    width: 100%;

    .MuiOutlinedInput-root {
      border-radius: 100px;
      color: ${COLOR.darkV2[32]};
      height: 44px;
    }

    .MuiOutlinedInput-input {
      padding: 8px 16px;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      letter-spacing: -0.4px;
      color: ${COLOR.indigo.default};
    }

    .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${COLOR.darkV2[32]};
    }
  }

  .apply-button {
    text-transform: none;
    padding: 8px 24px;
    min-width: 111px;
    border-radius: 25px;
    font-size: 16px;
    display: flex;
    justify-content: space-around;
    color: ${COLOR.darkBlue};
    height: 44px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.4px;
    &:disabled {
      opacity: 0.4;
    }
  }

  .voucher-error {
    color: ${COLOR.danger};
    font-size: 14px;
    margin: 0px 0px 0px 16px;
  }

  .add-voucher-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: pointer;

    .add-voucher-title {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.4px;
    }

    .expand-icon {
      width: 24px;
      height: 24px;
      font-weight: 400;
      color: ${COLOR.label[80]};
    }
  }

  .selected-voucher {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .voucher-gift-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background-color: ${COLOR.yellow.default};
      border-radius: 50%;
      padding: 4px;

      .gift-icon {
        width: 16px;
        height: 16px;
        color: ${COLOR.indigo.default};
      }
    }

    .voucher-name {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.4px;
    }

    .voucher-value {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.4px;
    }
    .voucher-amount-unit {
      font-weight: 400 !important;
      color: ${COLOR.label[80]} !important;
      border-bottom: 1px solid ${COLOR.label[80]} !important;
      margin-left: 2px;
    }

    .selected-voucher-button {
      text-transform: none;
      padding: 6px 24px;
      min-width: 95px;
      border-radius: 25px;
      font-size: 12px;
      display: none;
      justify-content: space-around;
      color: ${COLOR.darkBlue};
      font-weight: 500;
      line-height: 16px;
      letter-spacing: -0.4px;
    }

    &:hover {
      .selected-voucher-button {
        display: flex;
      }

      .voucher-value {
        display: none;
      }
    }
  }

  .voucher {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    cursor: pointer;
    border-radius: 12px;
    padding: 12px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border: 2px solid ${COLOR.label[8]};
    min-height: 58px;
    .tooltip-voucher {
      color: #1e164ea3;
    }
    .voucher-name {
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      color: ${COLOR.darkV2.default};
      letter-spacing: -0.4px;
    }

    .voucher-info-tooltip {
      display: flex;
      flex-direction: column;
      width: 100%;
      text-align: left;
      gap: 4px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: ${COLOR.white};
      letter-spacing: -0.4px;
    }

    .voucher-button {
      text-transform: none;
      padding: 6px 24px;
      min-width: 95px;
      border-radius: 25px;
      font-size: 12px;
      display: flex;
      justify-content: space-around;
      color: ${COLOR.darkBlue};
      min-height: 30px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: -0.4px;
    }

    .selected-voucher-button {
      display: none;
    }

    &:hover {
      .selected-voucher-button {
        display: flex;
      }
    }
  }
`;

const StyledPaymentFooter = styled('div')`
  display: flex;
  justify-content: ${(props) =>
    props.autorenew ? 'space-between' : 'flex-end'};
  justify-content: ${(props) => props.useNewLegal && 'space-between'};
  align-items: ${(props) => props.useNewLegal && 'center'};
  min-width: 80px;
  padding: 12px 16px;
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: ${COLOR.white};
  box-shadow: ${PAYMENT_FOOTER_SHADOW};

  .info-rounded-icon {
    font-size: 18px;
    cursor: pointer;
    margin-left: 4px;
    margin-bottom: 2px;
    color: #ff9500;
  }

  ${(props) =>
    props.useNewLegal &&
    `
    .auto-renew-term-container {
      display: flex;
    }
    .checkbox {
      padding: 0 9px 0 0px !important;
      color: ${COLOR.darkBlue} !important;
      height: 50%;
    }
    .not-agree-auto-renew-term-text {
      font-size: 14px;
      color: ${COLOR.functionalRed.default};
      font-weight: 400;
      line-height: 20px;
    }
    .agree-auto-renew-term-text {
      display: flex;
      flex-direction: column;
    }
  `}
  .term {
    font-size: 12px;
    font-weight: 400;
    color: ${COLOR.darkV2[64]};
    margin-top: -8px;

    a:-webkit-any-link {
      color: ${COLOR.darkV2[64]};
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .cancelNote {
    margin-top: -14px;
  }

  .container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    min-width: ${(props) => props.useNewLegal && '310px'};
  }

  .price {
    display: flex;
    line-height: 24px;
    align-items: center;
    margin-right: 12px;

    font-size: 16px;
    font-style: normal;
    font-weight: 700;

    .price-text {
      margin-right: 4px;
    }
  }

  .text-16 {
    font-size: 16px !important;
  }

  .discount-unit-price {
    font-size: 14px;
    text-transform: lowercase;
  }

  .discount-unit-price-small {
    font-size: 12px;
    text-transform: lowercase;
  }

  .underline {
    text-decoration: underline;
  }

  .agreeToPayButton {
    text-transform: none;
    padding: 2px;
    font-size: 16px;
    font-style: normal;
    font-weight: 510;
    display: flex;
    height: 44px;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 480px;
    text-wrap: no-wrap;
  }

  @media only screen and (min-width: ${BREAKPOINTS.SM}px) {
    left: ${(props) => `${props.sidebarwidth}px`};
  }

  @media only screen and (max-width: ${BREAKPOINTS.SM}px) {
    left: 0 !important;
  }

  @media only screen and (width: ${BREAKPOINTS.SM}px) {
    left: 62px !important;
  }

  @media (min-width: ${BREAKPOINTS.MD}px) {
    padding: 12px 40px;
    .container {
      display: flex;
      align-items: center !important;
      justify-content: flex-end !important;
    }
  }

  @media (min-width: ${BREAKPOINTS.MD + 1}px) {
    gap: ${(props) => (props.useNewLegal ? '32px' : '0')};
    padding: ${(props) => props.useNewLegal && '12px 16px'};
  }

  @media (min-width: ${BREAKPOINTS.SM}px) and (max-width: ${BREAKPOINTS.MD}px) {
    display: flex !important;
    align-items: flex-start !important;
    flex-direction: column !important;
    gap: ${(props) => props.useNewLegal && '16px'};
    padding: ${(props) => props.useNewLegal && '12px 16px'};
    .container {
      display: flex;
      justify-content: space-between !important;
      width: 100%;
    }
  }

  @media (max-width: ${BREAKPOINTS.SM}px) {
    display: flex !important;
    align-items: flex-start !important;
    flex-direction: column !important;
    gap: ${(props) => props.useNewLegal && '16px'};
    padding: ${(props) => props.useNewLegal && '12px 16px'};
    .container {
      display: flex;
      justify-content: space-between !important;
      flex-wrap: wrap;
      width: 100%;
      margin-top: ${(props) => (props.autorenew ? '4px' : '0')};
    }
  }
`;

const StyledSubscriptionInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .content {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .subscription-info-note {
    width: 18px;
    height: 18px;
    color: ${COLOR.indigo[32]};
    cursor: pointer;
  }
`;

const StyledBuyMoreCharacters = styled('div')`
  .head {
    display: flex;
    align-items: center;
    .title {
      color: #1c1c1e;
      font-size: 20px;
      font-weight: 700;
    }
    .product-name {
      padding: 4px 12px;
      border-radius: 480px;
      background-color: #1e164e14;
      box-sizing: border-box;
      color: #1e164e;
      font-size: 14px;
      margin-left: 8px;
      font-weight: 500;
      height: 32px;
      display: grid;
      place-content: center;
    }
  }
  .number-characters {
    display: flex;
    align-items: center;
    .tag-discount {
      .percent-icon {
        margin-right: 4px;
      }
      margin-left: 4px;
      background-color: #007aff14;
      color: #007aff;
      font-weight: 400;
      border-radius: 8px;
      padding: 4px 8px;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
  }
  .number-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 4px;
    height: 22px;
    .title-number-price {
      color: #1c1c1e;
      font-weight: 400;
      font-size: 16px;
    }
  }
  .number-character {
    color: #1c1c1e;
    font-weight: 700;
    font-size: 16px;
  }
  .info-character {
    color: #1c1c1ea3;
    font-weight: 400;
    font-size: 12px;
  }
  .line-through {
    text-decoration: line-through;
  }
  .cal-price {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  .cal-price-voucher {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
    height: 14px;
  }
  .price-per-number-character {
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.4px;
    font-weight: 400;
    font-style: italic;
    margin-top: 4px;
    color: #1c1c1ea3;
  }
  .slider {
    margin-top: 8px;
    position: relative;
    height: 32px;
    display: flex;
    align-items: center;
    .icon-rounded-left {
      position: absolute;
      cursor: pointer;
      left: 0;
      top: 28%;
      font-size: 14px;
      z-index: 101;
      color: #fff;
    }
    .icon-rounded-right {
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 28%;
      font-size: 14px;
      color: #fff;
    }
  }
  @media (max-width: ${BREAKPOINTS.SM}px) {
    .slider {
      width: 95%;
      margin-right: auto;
      margin-left: auto;
    }
  }
`;

const StyledDialogUpDownGradeV3 = styled('div')`
  .info-package-mirgate {
    font-size: 20px;
    color: #1c1c1e;
  }
  .list {
    margin-top: 16px;
    .item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      color: #1c1c1e;
    }

    .note-warning-lock-circle {
      display: flex;
      margin-top: 16px;
      align-items: center;
      margin-bottom: 8px;
      padding: 8px 12px;
      border-radius: 8px;
      background-color: #ff950014;
      .text-note {
        color: #1c1c1e;
        font-size: 14px;
        letter-spacing: -0.4px;
      }
      .icon-warning-lock-circle {
        width: 24px;
        color: #ff9500;
        margin-right: 5px;
      }

      .contents {
        display: flex;
        flex-direction: column;
      }
    }
  }
  .icon-check-circle {
    width: 16px;
    margin-right: 5px;
    color: #34c759;
  }
  .icon-error-circle {
    width: 16px;
    color: #ff9500;
    margin-right: 5px;
  }
  .icon-cancel-circle {
    width: 16px;
    margin-right: 5px;
    color: #ff3b30;
  }

  .icon-warning-lock-circle {
    width: 24px;
    color: #ff9500;
    margin-right: 5px;
  }

  .note-payment {
    font-weight: 400;
    font-size: 14px;
    color: #1c1c1ea3;
    margin-top: 8px;
  }
  .close-button {
    text-transform: none;
    padding: 8px 24px;
    border: 1px solid #1e164e52;
    border-radius: 12px;
  }
  .support-payment {
    font-weight: 400;
    background: #007aff14;
    padding: 4px 12px;
    border-radius: 8px;
    margin-top: 14px;
    span {
      font-size: 14px;
      color: #1c1c1e;
    }
  }
  .agree-button {
    text-transform: none;
    padding: 8px 24px;
    border-radius: 12px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0px;
  }
  .content {
    padding: 12px 0px;
  }
  .dialog-wrapper {
    gap: 22px;
  }
  .dialog-title {
    display: flex;
    gap: 8px;
    align-items: center;
    .icon {
      width: 24px;
      height: 24px;
    }
    .title {
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: -0.4px;
    }
  }
  .cancel-btn {
    border-color: ${COLOR.secondary[32]};
  }
  @media only screen and (max-width: 768px) {
    .header {
      padding: 6px 16px;
    }
    .dialog-title {
      display: flex;
      gap: 8px;
      align-items: center;
      .icon {
        width: 24px;
        height: 24px;
      }
      .title {
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.4px;
      }
    }
    .dialog-wrapper {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
    .dialog-title {
      text-align: left;
      font-weight: 700;
    }
    .dialog-action {
      justify-content: center;
      align-items: center;
      gap: 10px;
    }
    .dialog-message {
      padding: 12px 30px;
      .title-message {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 150% */
        letter-spacing: -0.4px;
      }
      .description {
        font-size: 14px;
        margin-left: 0px;
      }
    }
    .content-wrapper {
      margin-bottom: 4px;
    }
  }
`;

export {
  StyledDialogUpDownGradeV3,
  StyledBuyMoreCharacters,
  StyledPackageInfoItem,
  StyledPayment,
  StyledCreateInvoice,
  StyledInvoice,
  StyledPackageInfo,
  StyledPopover,
  StyledPaymentMethods,
  StyledPaymentMethodItem,
  StyledOrderInfo,
  StyledOrder,
  StyledUserOrderInfo,
  StyledVoucherBox,
  StyledPaymentFooter,
  StyledSubscriptionInfo,
};
